import tjFetch from '@common-libs/tj-fetch'

// apiConfig
let apiConfig = {}
apiConfig.thirdChannelLogin = '/feapi/passport-api/api/union'
apiConfig.getPrimaryUUid = '/bnbapp-node-h5/h5/sync/uid' // 获取原始uuid

let api = {}

api.getPrimaryUUid = function() {
  return tjFetch.post(apiConfig.getPrimaryUUid)
}

/**
 * [getCommonConfig 获取H5公共配置信息]
 *  @param  {[string]} channelCode 渠道code
 */
api.getCommonConfig = function({ channelCode }) {
  apiConfig.getCommonConfig = '/feapi/bingo/h5/Config/getCommonConfigs'

  return tjFetch.post(apiConfig.getCommonConfig, {
    data: arguments[0]
  })
}

/**
 * 三方登陆
 * channel: elong/
 * elongTokenData:{ accessToken, lastAccessToken }
 */
api.thirdChannelLogin = async function({ channel, tokenData, platformType = '' }) {
  let enumOAuthSite = ''
  switch (channel) {
  case 'elong':
    enumOAuthSite = 1005
    break
  default:
    break
  }

  // 接口失败 自动重试一次
  const fn = () => tjFetch.post(apiConfig.thirdChannelLogin, { data: Object.assign({ enumOAuthSite, platformType }, tokenData) })

  let res = await fn()
  if (!res.isSuccess) {
    res = await fn()
  }
  return res
}

api.getWechatJsSdkConfig = function({ url }) {
  apiConfig.getWechatJsSdkConfig = '/feapi/bingo/h5/Config/getwxsdkconfig'
  return tjFetch.post(process.env.VUE_APP_M_TUJIA_HOST + apiConfig.getWechatJsSdkConfig, {
    data: arguments[0]
  })
}

export default api
